<template>
  <div class="userService">
    <div class="header">用户服务协议</div>
    <div class="con">
      服务条款
      <p>重要须知：本公司在此特别提醒用户认真阅读、充分理解本《本公司服务条款》--- 用户应认真阅读本《本公司服务条款》 （下称《服务条款》）中各条款， 包括免除或者限制本公司责任的免责条款及对用户的权利限制条款。请您认真审阅并选择接受或不接受本《服务条款》（未成年人应在法定监护人陪同下审阅）。除非您接受本《服务条款》条款，否则您无权下载、安装或使用“本公司”及其相关服务。您的下载、安装、使用、账号获取和登录等行为将视为对本《服务条款》的接受，并同意接受本《服务条款》各项条款的约束。</p>
      <p>本《服务条款》是您（下称“用户”）与本公司之间关于用户访问“本公司”，注册、使用、管理账户，及使用其提供的相关服务所订立的协议。本《服务条款》描述本公司与用户之间关于“本公司”许可使用及相关方面的权利义务。“用户”或“您”是指通过本公司提供的获取“本公司动漫作品”授权的途径获得授权许可的个人或单一实体。</p>
      <p>本《服务条款》可由本公司随时更新，更新后的服务条款一旦公布即代替原来的服务条款，恕不再另行通知。用户可重新下载安装本公司或其相关服务查阅最新版协议条款。在本公司修改《服务条款》后，如果用户不接受修改后的条款，请立即停止使用“本公司”提供的软件和服务，用户继续使用“本公司”提供的软件和服务将被视为已接受了修改后的服务条款。</p>
     </div>
    <div class="serviceWrap" v-for="(item, index) in serviceList " :key="index">
      <div class="serviceWrap_title">{{ item.title }}</div>
      <div class="serviceWrap_con" v-if='item.id == 1'>
        <p>1.1 “本公司”由本公司开发。“本公司”的一切版权、商标权、专利权、商业秘密等知识产权，以及相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图表、色彩、界面设计、版面框架、有关数据、印刷材料、或电子文档等均为本公司所有，受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护。</p>
        <p>1.2 未经本公司书面同意，用户不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何三方实施、利用、转让上述知识产权，本公司保留追究上述未经许可行为的权利。</p>
      </div>
      <div class="serviceWrap_con" v-if='item.id == 2'>
        <p>2.1 用户承诺以其真实身份注册成为本公司及其经营网站和漫画平台的用户，并保证所提供的个人信息真实、完整、有效。真实、完整、有效的个人信息，对于使用“本公司”及其相关服务、暂停用户账号使用，及找回丢失账号至关重要。如因用户提供虚假资料或被他人获悉自己的注册资料，从而导致的损失由用户本人承担，损失包括但不限于因资料虚假或被他人获悉而无法使用的帐号。</p>
        <p>2.2 用户以真实身份注册成为本公司的用户后，需要修改所提供的个人身份资料信息的，应当及时通过本公司公布的方式，修改保存在本公司的个人身份资料信息。本公司将及时、有效地为用户提供相关服务。</p>
        <p>2.3 本公司有权审查用户注册所提供的身份信息是否真实、有效，并将采取技术与管理等合理措施保障用户账号的安全、有效；用户有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形，并给用户和他人的民事权利造成损害的，应当承担由此产生的法律责任。</p>
        <p>2.4 用户以真实身份注册成为本公司的用户后，可以使用“本公司”及其相关服务，但本公司保留对未来服务改变和说明的权利。用户账号的所有权归本公司，用户完成注册手续后，获得账号的使用权。用户对登录后所使用账号所产生的行为依法享有权利和承担责任。</p>
        <p>2.5 用户帐号使用权仅属于初始申请注册人，禁止赠与、借用、租用、转让或售卖。如果本公司发现使用者并非帐号初始注册人，本公司有权在未经通知的情况下回收该帐号而无需向该帐号使用人承担法律责任，由此带来的包括并不限于用户通讯中断、用户资料和漫画道具等清空等损失由用户自行承担。本公司禁止用户私下有偿或无偿转让帐号，以免因帐号问题产生纠纷，用户应当自行承担因违反此要求而遭致的任何损失，同时本公司保留追究上述行为人法律责任的权利。</p>
        <p>2.6 用户发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据本公司公布的处理方式通知本公司，并有权通知本公司采取措施暂停该账号的登录和使用。</p>
        <p>2.7 本公司根据用户的通知采取措施暂停用户账号的登录和使用的，本公司应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息。</p>
        <p>2.7.1 本公司核实用户所提供的个人有效身份信息与所注册的身份信息相一致的，将及时采取措施暂停用户账号的登录和使用。本公司仅负责核实申请用户提供的个人有效身份信息是否与注册的身份信息相一致，但无法识别申请用户是否为真正的拥有账号使用权的用户。</p>
        <p>2.7.2 本公司违反2.7.1款项的约定，未及时采取措施暂停用户账号的登录和使用，因此给用户造成损失的，将承担相应的法律责任。</p>
        <p>2.7.3 用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，本公司有权拒绝用户的上述请求。</p>
        <p>2.8 用户为了维护其合法权益，向本公司提供与所注册的身份信息相一致的个人有效身份信息时，本公司将为用户提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。</p>
        <p>2.9 用户注册帐号后如果长期不使用，本公司有权采取清除账号内信息或回收帐号等措施，以免造成资源浪费，由此带来的包括并不限于用户通信中断、用户资料、邮件和漫画道具丢失等损失由用户自行承担。</p>  
      </div>
      <div class="serviceWrap_con" v-if='item.id == 3'>
      <p>3.1 用户可以为非商业目的在单一台终端设备(下统称“终端设备”)上安装、使用、显示、运行“本公司”及其相关服务。用户不得为商业运营目的安装、使用、运行“本公司”及其相关服务，不可以对“本公司”及其相关服务运行过程中释放到任何终端设备内存中的数据及“本公司”及其相关服务运行过程中客户端与服务器端的交互数据进行复制、更改、修改、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经授权的第三方工具/服务接入“本公司”及其相关服务和相关系统。</p>
      <p>3.2 保留权利： 本《服务条款》未明示授权的其他一切权利仍归本公司所有， 用户使用其他权利时须另外取得本公司的书面同意。</p>
      <p>3.3 除本《服务条款》有明确规定外，本《服务条款》并未对利用“本公司”访问的本公司的其他服务规定相关的服务条款，对于这些服务可能有单独的服务条款加以规范，请用户在使用有关服务时另行了解与确认。如用户使用该服务，视为对相关服务条款的接受。</p> 
      </div>
      <div class="serviceWrap_con" v-if='item.id == 4'>
        <p>4.1 用户在遵守法律及本《服务条款》的前提下可依本《服务条款》访问“本公司”，及使用其提供的相关服务。用户无权实施包括但不限于下列行为：</p>
        <p>4.1.1 删除“本公司”及其他副本上所有关于版权的信息、内容；</p>
        <p>4.1.2 对“本公司”进行反向工程、反向汇编、反向编译等；</p>
        <p>4.1.3 用户通过非本公司开发、授权或认可的第三方兼容软件、系统登录或使用“本公司”及其服务，用户针对本公司的软件和服务使用非本公司开发、授权或认证的插件和外挂；</p>
        <p>4.1.4 对于“本公司”相关信息等，未经本公司书面同意，用户不得擅自实施包括但不限于下列行为：使用、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助“本公司漫画”发展与之有关的衍生产品、作品、服务、插件、外挂、兼容、互联等；</p> 
        <p>4.1.5利用“本公司”发表、传送、传播、储存违反国家法律、危害国家安全、祖国统一、社会稳定的内容，或任何不当的、侮辱诽谤的、淫秽的、暴力的及任何违反国家法律法规政策的内容；</p>
        <p>4.1.6 利用“本公司”发表、传送、传播、储存侵害他人知识产权、商业秘密权等合法权利的内容；</p>
        <p>4.1.7 利用“本公司”误导、欺骗他人；</p>
        <p>4.1.8 利用“本公司”使用任何包含有通过侵犯商标、版权、专利、商业机密或任何一方的其他专有权利的方式利用“本公司”获得的图像或相片的资料或信息；</p>
        <p>4.1.9 传送或散布以其他方式实现传送含有受到知识产权法律保护的图像、相片、软件或其他资料的文件，作为举例（但不限于此）：包括版权或商标权（或隐私权或公开权），除非用户拥有或控制着相应的权利或已得到所有必要的认可；</p>
        <p>4.1.10 利用本“本公司”及其服务批量发表、传送、传播广告信息及垃圾信息；</p>
        <p>4.1.11进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/帐户；未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；未经许可，企图探查、扫描、测试“本公司”系统或网络的弱点或其它实施破坏网络安全的行为； 企图干涉、破坏“本公司”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；伪造TCP/IP数据包名称或部分名称；</p>
        <p>4.1.12通过修改或伪造“本公司”及其服务运行中的指令、数据、数据包，增加、删减、变动“本公司”及其服务的功能或运行效果，将用于上述用途的软件通过信息网络向公众传播或者运营；</p>
        <p>4.1.13用户制作、发布、传播用于窃取帐号及他人专属信息、财产、保密信息的软件</p>
        <p>4.1.14在未经本公司书面明确授权前提下，出售、出租、出借、散布、转移或转授权“本公司”及其服务或相关的链接或从使用“本公司”及其服务或“本公司”及其服务的条款中获利，无论以上使用是否为直接经济或金钱收益；</p>
        <p>4.1.15其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用“本公司”及其提供的服务；</p>
        <p>4.1.16用户若违反上述规定，本公司有权采取终止、完全或部分中止、限制用户帐号的使用功能。</p> 
        <p>4.2 访问“本公司”必须遵守国家有关法律和政策，维护国家利益，保护国家安全，并遵守本《服务条款》，对于用户违法或违反本《服务条款》的使用而引起的一切责任，由用户负全部责任，一概与本公司及合作单位无关，导致本公司及合作单位损失的，本公司及合作单位有权要求用户赔偿，并有权立即停止向其提供服务，保留相关记录，保留配合司法机关追究法律责任的权利。而且，对于用户违法或违反本《服务条款》以及违反了“本公司”及其服务的其他相关服务条款，本公司有权视用户的行为性质，在不事先通知用户的情况下，采取包括但不限于中断使用许可、停止提供服务、限制使用、回收用户帐号、法律追究等措施。对利用帐号进行违法活动、骚扰、欺骗其他用户等行为，本公司有权回收其帐号。由此带来的包括并不限于用户通信中断、用户资料、邮件和漫画道具丢失等损失由用户自行承担。</p>
        <p>4.3 “本公司”同大多数互联网软件一样，可能受到各种安全问题的侵扰，用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，以免遭致损失和骚扰。用户知晓账号及密码保管责任在于用户，对于用户因他人冒名使用账号而致的任何损失，本公司不承担责任。</p>
        <p>4.4 非经本公司或本公司授权开发并正式发布的其它任何由“本公司”衍生的软件均属非法，下载、安装、使用此类软件，将可能导致不可预知的风险，建议用户不要轻易下载、安装、使用，由此产生的一切法律责任与纠纷一概与本公司无关。用户不得轻易下载、安装、使用此类软件，否则，本公司有权在不事先通知用户的情况下单方面终止用户帐号的使用资格。</p>
        <p>用户只能通过本公司提供的“本公司”及其他合法通道登录使用“本公司”及其相关服务。用户不得通过其他未经本公司授权开发的包括但不限于非法兼容型软件、程序或者其他非本公司明示许可的方式，登录使用帐号，否则，本公司有权在不事先通知用户的情况下单方面终止用户帐号的使用资格。</p>
        <p>4.5 未成年人上网应该在父母和老师的指导下，正确学习使用网络。未成年人要避免沉迷虚拟的网络世界而影响了日常的学习生活。</p>
        <p>4.6 本公司保留在任何时候根据适用法律、法规、法律程序或政府要求的需要而披露任何信息，或由本公司自主决定全部或部分地编辑、拒绝张贴或删除任何信息或资料的权利。</p>
        <p>4.7 软件的替换、修改和升级：本公司保留在任何时候通过为您提供本软件替换、修改、升级版本的权利以及为替换、修改或升级收取费用的权利。</p>
        <p>本公司保留因业务发展需要，单方面对软件的部分功能效果进行改变或进行限制，用户需承担此风险。</p>
        <p>4.8 本软件可能使用的第三方软件或技术，是受到合法授权的。因第三方软件或技术引发的任何纠纷，由该第三方负责解决，本公司不承担任何责任。 本公司不对第三方软件或技术提供客服支持，若您需要获取支持，请与该软件或技术提供商联系。</p>
        <p>4.9 本公司有权在服务中或经过服务投放各种广告和宣传信息，该广告/宣传信息可能以系统消息或弹出窗口等形式出现。</p>
      </div>
      <div class="serviceWrap_con" v-if='item.id == 5'>
      <p>5.1 用户认可本公司将会尽其商业上的合理努力以保护用户的计算机资源及计算机通讯的隐私性和完整性，但是，用户承认和同意本公司不能就此事提供任何保证。</p>
      <p>5.2 本公司特别提请用户注意：本公司为了保障公司业务发展和调整的自主权，拥有随时自行修改或中断软件或服务授权而不需通知用户的权利，如有必要，修改或中断会以通告形式公布于本公司网站重要页面上。</p>
      <p>5.3 用户有进行4.1款规定的行为、发布违法信息、严重违反社会公德、以及其他违反法律的禁止性规定的行为，本公司将立即终止对用户提供服务。</p>
      <p>5.4 用户违反本《服务条款》或相关的服务条款的规定，导致或产生的任何第三方主张的任何索赔、要求或损失，包括合理的诉讼费用和律师费用，您同意赔偿本公司与合作公司、关联公司，并使之免受损害。对此，本公司有权视用户的行为性质，采取包括但不限于中断使用许可、停止提供服务、限制使用、法律追究等措施。</p> 
        <p>5.5 访问“本公司”由用户自己承担风险，本公司对“本公司”不作任何类型的担保，不论是明示的、默示的或法令的保证和条件，包括但不限于“本公司”的适销性、适用性、无病毒、无疏忽或无技术瑕疵问题、所有权、平静受益权、和无侵权的明示或默示担保和条件，对在任何情况下因使用或不能使用“本公司”所产生的直接、间接、偶然、特殊及后续的损害及风险，本公司及合作单位不承担任何责任。</p>
        <p>5.6 访问“本公司”涉及到互联网服务，可能会受到各个环节不稳定因素的影响，存在因不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机，非法内容信息、骚扰信息屏蔽以及其他任何网络、技术、通信线路、信息安全管理措施等原因造成的服务中断或不能满足用户要求的风险，用户须明白并自行承担以上风险，本公司与合作公司、关联公司不承担任何责任。</p>
        <p>5.7 使用“本公司”及其服务可能存在来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息的风险，用户须明白并自行承担以上风险，本公司及合作单位、关联公司不对任何有关信息真实性、适用性、合法性承担责任。</p>
        <p>5.8 用户因第三方如电信部门的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，本公司及其合作单位、关联公司不承担责任。</p>
        <p>5.9 因技术故障等不可抗力事件影响到“本公司”及其服务的正常运行的，本公司及合作单位承诺在第一时间内与相关单位配合，及时处理进行修复，但用户因此而遭受的一切损失，本公司及合作单位不承担责任。</p>
        <p>5.10 用户之间通过“本公司”及其服务与其他用户交往，因受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失，由过错方依法承担所有责任，一概与本公司及合作单位、关联公司无关。</p>
    </div>
      <div class="serviceWrap_con" v-if='item.id == 6'>
        <p>6.1 尊重用户个人隐私是本公司的一项基本政策。“隐私”是指用户在注册本公司及相关漫画账号时提供给本公司的个人身份信息，包括用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等。而“隐私”不包括用户对“本公司”及其服务的操作状态以及使用习惯等一些明确且客观反映在本公司服务器端的基本记录信息和其他一切个人隐私信息范围外的普通信息。本公司一贯积极地采取技术与管理等合理措施保障用户账号的安全、有效；本公司将善意使用收集的信息，采取各项有效且必要的措施以保护用户的隐私安全，并使用商业上合理的安全技术措施来保护用户的隐私不被未经授权的访问、使用或泄漏。</p>
        <p>6.2 因业务所需，本公司需与本公司的关联公司共享用户注册信息，本公司及关联公司承诺将善意使用其个人信息，本公司将不会向除关联公司外的任何其他方公开或共享用户注册资料的中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：</p>
        <p>6.2.1用户或用户监护人授权本公司披露的（如：用户在选择某项服务时选择或同意公开、使用其个人信息）；</p>
        <p>6.2.2有关法律要求本公司披露的；</p>
        <p>6.2.3司法机关或行政机关基于法定程序要求本公司提供的；</p>
        <p>6.2.4本公司为了维护自己合法权益而向用户提起诉讼或者仲裁时；</p>
        <p>6.2.5应用户监护人的合法要求而提供用户个人身份信息时。</p>
      </div>
      <div class="serviceWrap_con" v-if='item.id == 7'>
        <p>7.1 本《服务条款》所定的任何条款的部分或全部无效者，不影响其它条款的效力。</p>
        <p>7.2 本《服务条款》的解释、效力及纠纷的解决，适用于中华人民共和国法律。若用户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户在此完全同意将纠纷或争议提交本公司所在地法院管辖。</p>
        <p>7.3 在法律容许的范围内，本公司拥有对本《服务条款》的解释权与修改权。</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
let serviceList = ref([
  { title: '1 权利声明', id: 1 }, { title: '2 账号注册、使用和保管', id: 2 }, { title: '3 用户使用许可授权范围', id: 3 }, { title: '4 用户使用须知', id: 4 }, { title: '5 法律责任与免责', id: 5 }, { title: '6 用户隐私权保护和个人信息利用', id: 6 }, { title: '7 其他条款', id: 7 }
])

</script>

<style lang="scss" scoped>
.userService {
  .header {
    font-size: 28px;
    
    color: #333333;
    line-height: 40px;
  }

  .con {
    font-size: 18px;
    font-weight: 400;font-weight: lighter;
    color: #333333;
    line-height: 36px;
    margin-top: 30px;
  }

  .serviceWrap {
    &_title {
      // background-color: rgb(255, 127, 170);
      font-size: 22px;
      
      color: #333333;
      line-height: 30px;
      margin: 30px 0 20px;
    }

    &_con {
      font-size: 18px;
      font-weight: 400;font-weight: lighter;
      color: #333333;
      line-height: 36px;
    }

    &_con1 {
      font-size: 16px;
    }
  }

}
</style>